import { CheckIcon, Cross2Icon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";

export default function PasswordValidation({ password }) {
    const [validations, setValidations] = useState({
        length: false,
        number: false,
        lowercase: false,
        uppercase: false,
        specialChar: false,
        noSpaces: false,
    });

    useEffect(() => {
        setValidations({
            length: password.length >= 8 && password.length <= 20,
            number: /[0-9]/.test(password),
            lowercase: /[a-zåäö]/.test(password),
            uppercase: /[A-ZÅÄÖ]/.test(password),
            specialChar: /[@!.#$%^&-+=()]/.test(password),
            noSpaces: !/\s/.test(password),
        });
    }, [password]);

    return (
        <ul className="text-sm">
            <li className={`flex items-center ${validations.length ? "text-green-600" : "text-destructive"}`}>
                Lösenordet måste vara mellan 8 och 20 tecken långt. {validations.length ? <CheckIcon className='ml-1' /> : <Cross2Icon className='ml-1' />}
            </li>
            <li className={`flex items-center ${validations.number ? "text-green-600" : "text-destructive"}`}>
                Det måste innehålla minst en siffra (0-9). {validations.number ? <CheckIcon className='ml-1' /> : <Cross2Icon className='ml-1' />}
            </li>
            <li className={`flex items-center ${validations.lowercase ? "text-green-600" : "text-destructive"}`}>
                Det måste innehålla minst en liten bokstav (a-ö). {validations.lowercase ? <CheckIcon className='ml-1' /> : <Cross2Icon className='ml-1' />}
            </li>
            <li className={`flex items-center ${validations.uppercase ? "text-green-600" : "text-destructive"}`}>
                Det måste innehålla minst en stor bokstav (A-Ö). {validations.uppercase ? <CheckIcon className='ml-1' /> : <Cross2Icon className='ml-1' />}
            </li>
            <li className={`flex items-center ${validations.specialChar ? "text-green-600" : "text-destructive"}`}>
                Det måste innehålla minst ett specialtecken (@#$%^&-+=()). {validations.specialChar ? <CheckIcon className='ml-1' /> : <Cross2Icon className='ml-1' />}
            </li>
            <li className={`flex items-center ${validations.noSpaces ? "text-green-600" : "text-destructive"}`}>
                Inga mellanslag är tillåtna. {validations.noSpaces ? <CheckIcon className='ml-1' /> : <Cross2Icon className='ml-1' />}
            </li>
        </ul>
    );
}